<template>
    <layout v-slot="layoutScope" title="Mi carrito de compras">
        <div id="primary" class="content-area width-normal">
            <main id="main" class="site-main">
                <div class="cont maincont">
                    <h1 class="maincont-ttl">Mi carrito</h1>
                    <ul class="b-crumbs">
                        <li><a href="index.html">Inicio</a></li>
                        <li>Carrito</li>
                    </ul>

                    <div class="page-styling">
                        <div v-if="Object.keys(_cart.details).length" class="woocommerce prod-litems section-list">

                            <cart-item
                                v-for="item in _cart.details"
                                :key="item.rowId"
                                :item="item"

                            ></cart-item>

                        </div>
                        <div v-else style="background-color: white; padding: 40px 20px 30px 20px; margin-bottom: 20px;">
                            <h2 class="text-center" style="color: #777;">Aún no has agregado productos en el carrito</h2>
                        </div>
                        <!-- REMOVE STYLE IN cart-actions IF CUPPON SHOW -->
                        <div class="bg-white px-6 py-6">
                            <!-- <div class="coupon">
                                <input type="text" placeholder="Coupon code">
                                <input type="submit" class="button" value="Apply">
                            </div> -->
                            <div class="flex flex-col gap-y-2 items-center md:flex-row md:justify-between">
                                <div class="text-center">
                                    <div class="font-bold">Subtotal</div>
                                    <div v-if="_cart" class="text-gray-600 text-lg">${{ _cart.subtotal }}</div>
                                </div>
                                <div class="text-center">
                                    <div class="font-bold">Total</div>
                                    <div v-if="_cart" class="text-green-500 text-xl">${{ _cart.total }}</div>
                                </div>
                                <inertia-link href="/productos" class="btn btn-success rounded-sm" style="color: white;">SEGUIR COMPRANDO</inertia-link>
                                <inertia-link v-if="Object.keys(_cart.details).length" href="/checkout" class="btn btn-success rounded-sm" style="color: white;">FINALIZAR</inertia-link>
                            </div>
                        </div>

                    </div>
                </div>
            </main><!-- #main -->
        </div>

    </layout>
</template>

<script>
import Layout from '../Layout';
import CartItem from '../../components/Cart/CartItem';

export default {
    components: {
        Layout,
        CartItem,
    },
    props: {
        _cart: Object,
    }
}
</script>

<style>

</style>
